import { regions, ui, collectionEvents, events, initialize, onShow, onInitIsotope, collectionChange, checkMosaicLoadMore, waitForLoadMoreRequest, infiniteLoadMore } from 'mosaic_v2/mosaic_v2_layout_view';
import { onRender, behaviors, childViewOptions, resizeHeader, onInitMosaicCalculations, showLoadMore, hideLoadMore } from 'mosaic_v2/mosaic_v2_composite_view';

Pixlee.module('MosaicV2App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions,
        ui,
        collectionEvents,
        events,

        initialize: function() {
            initialize.call(this, App.displayOptions);
        },

        onShow: function() {
            this.checkDesignEditor();
            onShow.call(this);
        },

        checkDesignEditor: function() {
            var href = window.location.href;
            if (href.indexOf('design_editor_device=tablet') > -1) {
                this.$el.addClass('mosaic_design_editor');
            }
        },

        onInitIsotope,
        collectionChange,
        checkMosaicLoadMore,
        infiniteLoadMore: function() { infiniteLoadMore.call(this, App) },
        waitForLoadMoreRequest: function() { waitForLoadMoreRequest.call(this, window) },

        loadMore: function() {
            var loadMore = this.checkMosaicLoadMore();
            if (loadMore) {
                this.ui.loadMore.addClass('loading');
                this.collection.nextPage({
                    success: function() {
                        this.ui.loadMore.removeClass('loading');
                        App.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                        loadMore = this.checkMosaicLoadMore();
                        if (!loadMore) {
                            this.ui.loadMore.hide();
                        }
                    }.bind(this)
                });
            }
        },
    });
    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);


    Show.PhotoView = App.Views.ItemView.extend({
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        modelEvents: {
            'voted': 'onVotePhoto'
        },
        getTemplate: function() {
            var elementSize = this.model.get('elementSize');
            // If the widget is infinite load, photo sizes are completely random
            if (this.options.isInfiniteLoad) {
                if (_.random(0, 1)) {
                    elementSize = 'large';
                } else {
                    elementSize = 'small';
                }
                this.model.set('elementSize', elementSize);
            }
            var isLargeTemplate = _.contains(['xl', 'original'], this.options.photoQuality) && this.options.model.get('content_type') === 'image';
            if (isLargeTemplate && elementSize === 'large') {
                return require('../../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                return require('../../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        onShow: function() {
            this.triggerMethod('watch:top:change');
            this.triggerMethod('set:element:size:class');
        },
        onWatchTopChange: function() {
            var collection = this.model.collection;
            var index = collection.indexOf(this.model);
            var absoluteIndex = index - this.options.initialLength;
            var animationOffset = absoluteIndex > 0 ? (absoluteIndex * 50) : 0;
            var _this = this;
            this.$el.watch({
                properties: 'top,left',
                callback: function(data, i) {
                    setTimeout(function() {
                        if (_this.isIE()) {
                            $(this).addClass('IE_fix');
                        } else {
                            $(this).addClass('fade_in_js');
                        }
                        // run only once - delay to ensure ops have run aren't reset
                        setTimeout(function() {
                            $(this).unwatch(data.id);
                        }.bind(this), 10);
                    }.bind(this), 500 + animationOffset);
                }
            });
        },
        onSetElementSizeClass: function() {
            this.$el.addClass(this.model.get('elementSize'));
        },
        isIE: function() {
            return (navigator.userAgent.indexOf('MSIE') !== -1) || (!!window.MSInputMethodContext && !!document.documentMode);
        },
        onVotePhoto: function() {
            this.$el.find('.vote_button').addClass('active');
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    Show.MosaicCollection = App.Views.CompositeView.extend({
        template: require('./templates/_collection_view.jst.ejs'),
        childView: Show.PhotoView,
        childViewContainer: '#item_container',
        childViewOptions: function() { return childViewOptions.call(this, gon); },
        behaviors,

        initialize: function(options) {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };

            //if this isn't infinite load, we wanna run the mosaic calc
            this.runMosaicCalculation = !(gon.display_options && gon.display_options.infiniteLoadMore);
            this.collectionHasSynced = false;

            gon.fresh_images = [];
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            this.safariTimeOut = isSafari ? 100 : 0;
            this.initialLength = 0;
            this.collectionQueue = options.collectionQueue;
            this.triggerMethod('init:mosaic:calculations');
        },

        onShow: function() {
            //if the sync hasn't returned yet we wanna run the calc
            if (this.runMosaicCalculation && this.collectionHasSynced) {
                this.triggerMethod('calculate:perfect:mosaic');
            }

            var calculationBlock = $('#calculation_block');
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            this.maxOuterPhotoWidth = calculationBlock.outerWidth(true) || 0;
            this.calculationBlockWidth = isSafari ? 0 : calculationBlock[0].getBoundingClientRect().width || 0;
            this.maxPhotoWidth = calculationBlock.outerWidth() || 0;
            calculationBlock.remove();
            $(window).resize(resizeHeader.bind(this));
            $('#widget').attr('alt', App.altText);
            this.runMosaicCalculation = true; //so load more can work
        },

        onCalculatePerfectMosaic: function() {
            // Calculation Constants
            var itemContainerWidth = $('#item_container').width();
            var viewPortWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var vw = viewPortWidth / 100;
            var smallPhotoWidth = (24 * vw) - 3;
            smallPhotoWidth = (smallPhotoWidth >= 0) ? smallPhotoWidth : 0;

            // Grab smallPhotoWidth from the max photo width of a small element else default fallback
            smallPhotoWidth = (this.calculationBlockWidth > 1) ? this.calculationBlockWidth : smallPhotoWidth;
            // Initial Calculation
            var totalSmallGridWidth = Math.floor(itemContainerWidth / smallPhotoWidth);
            // Call behavior file 'perfectMosaicHelpers' to kick off calculations
            this.calculatePhotoSizes(totalSmallGridWidth);
        },

        onRender,
        onInitMosaicCalculations,
        showLoadMore,
        hideLoadMore
    });
    Show.MosaicCollection.include(['headerHelpers', 'perfectMosaicHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);


    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});
